import { cn } from "@/core/helpers/cn";

type ATMInputProps = {
  variant?: "light" | "dark";
  type?: "number" | "text";
  value?: string;
  icon?: React.ReactNode;
  onChange?: (value: string) => void;
  onMaxClick?: () => void;
  placeholder?: string;
  className?: string;
  maxValue?: number;
};

export function ATMInput({
  variant = "light",
  type = "number",
  value = "",
  icon,
  onChange,
  onMaxClick,
  placeholder = "Сумма в рублях",
  className,
  maxValue,
}: ATMInputProps) {
  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    const newValue = e.target.value;
    onChange?.(newValue);
  }

  function handleMaxClick() {
    if (maxValue) {
      const maxValueStr = maxValue.toString();
      onChange?.(maxValueStr);
    }
    onMaxClick?.();
  }

  return (
    <div
      className={cn(
        "relative h-[44px] flex items-center w-full rounded-xl px-4 gap-3",
        variant === "dark" && "bg-dark-800",
        variant === "light" && "bg-white",
        "shadow-sbank-control",
        className,
      )}
    >
      {icon || (
        <div
          className={cn(
            "flex-shrink-0 size-[20px] rounded-full flex items-center justify-center",
            variant === "dark" && "bg-white/30 text-dark-900",
            variant === "light" && "bg-[#186d27] text-white",
          )}
        >
          <span className="font-bold text-16 leading-none">₽</span>
        </div>
      )}

      <input
        type={type}
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        className={cn(
          "flex-1 bg-transparent border-none outline-none  text-base font-medium",
          variant === "dark" && "text-white placeholder:text-white/50",
          variant === "light" && "text-dark-800 placeholder:text-sbank-muted",
        )}
      />

      {onMaxClick && (
        <button
          type="button"
          onClick={handleMaxClick}
          className={cn(
            "flex-shrink-0 px-2 py-0.5 rounded-md font-bold text-sm transition-colors duration-200",
            variant === "dark" && "bg-white/3 hover:bg-white/10 text-white/50",
            variant === "light" && "bg-green-700/10 hover:bg-green-700/20 text-[#186d27]",
          )}
        >
          Макс.
        </button>
      )}
    </div>
  );
}
